<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator />
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div style="" class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-button type="primary" @click="openStudentQuestionnaireEditor">问卷调查</el-button>
          </div>
        </div>
      </el-col>
    </el-row>

    <studentQuestionnaireEditor key="studentQuestionnaireEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" />
  </div>
</template>

<script>
import { getStudentCoursesQuestionnaireStatus } from "@/service/questionnaire.service";

export default {
  name: "test",
  components: {
    navigator: () => import("@/components/navigator"),
    studentQuestionnaireEditor: () =>
      import("@/components/questionnaire/studentQuestionnaireEditor"),
  },
  data() {
    return {
      name: "",
      age: "",
      answers: {
        q1: null,
        q2: null,
      },
      studentCoursesQuestionnaireStatus: [],
    };
  },
  created() {
    this.loadStudentCoursesQuestionnaireStatusFromServer();
  },
  methods: {
    async loadStudentCoursesQuestionnaireStatusFromServer() {
      let studentId = 20705;
      try {
        let result = await getStudentCoursesQuestionnaireStatus(studentId);

        this.studentCoursesQuestionnaireStatus =
          !!result && result.success ? result.data : [];
      } catch (error) {
        console.error(error);
      }
    },

    openStudentQuestionnaireEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "studentQuestionnaireEditor"
      );
      if (!refEditor) return;

      refEditor.showDialog(22826, 22772);
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-rate {
  /deep/ .ai-rate__content {
    .ai-rate__content__item {
      border-style: none;

      &.is-active,
      &.is-hover-active {
        background-color: var(--choice-bg-color-active, #409eff);
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/admin/test.vue